import type { ReactNode } from 'react'
import { useParams } from '@tanstack/react-router'
import { MemberAccountPage } from '@features/member-access/ui/MemberAccountPage'
import { MemberAreaGate } from '@features/member-access/ui/MemberAreaGate'
import { MemberCoursePage } from '@features/member-access/ui/MemberCoursePage'
import { MemberFilesPage } from '@features/member-access/ui/MemberFilesPage'
import { MemberLessonPage } from '@features/member-access/ui/MemberLessonPage'
import { MemberLockedCoursePage } from '@features/member-access/ui/MemberLockedCoursePage'
import { MemberLibraryPage } from '@features/member-access/ui/MemberLibraryPage'
import { MemberLoginPage } from '@features/member-access/ui/MemberLoginPage'
import { MemberMagicLinkPage } from '@features/member-access/ui/MemberMagicLinkPage'

function useAccessParams() {
  const { producerId = '', productId, lessonId } = useParams({ strict: false })
  return { producerId, productId, lessonId }
}

function gated(producerId: string, page: ReactNode) {
  return <MemberAreaGate producerId={producerId}>{page}</MemberAreaGate>
}

export function MemberLoginRoutePage() {
  const { producerId } = useAccessParams()
  return gated(producerId, <MemberLoginPage producerId={producerId} />)
}

export function MemberMagicRoutePage() {
  const { producerId } = useAccessParams()
  return gated(producerId, <MemberMagicLinkPage producerId={producerId} />)
}

export function MemberLibraryRoutePage() {
  const { producerId } = useAccessParams()
  return gated(producerId, <MemberLibraryPage producerId={producerId} />)
}

export function MemberAccountRoutePage() {
  const { producerId } = useAccessParams()
  return gated(producerId, <MemberAccountPage producerId={producerId} />)
}

export function MemberCourseRoutePage() {
  const { producerId, productId = '' } = useAccessParams()
  return gated(producerId, <MemberCoursePage producerId={producerId} productId={productId} />)
}

export function MemberLockedCourseRoutePage() {
  const { producerId, productId = '' } = useAccessParams()
  return gated(producerId, <MemberLockedCoursePage producerId={producerId} productId={productId} />)
}

export function MemberLessonRoutePage() {
  const { producerId, productId = '', lessonId = '' } = useAccessParams()
  return gated(
    producerId,
    <MemberLessonPage producerId={producerId} productId={productId} lessonId={lessonId} />,
  )
}

export function MemberFilesRoutePage() {
  const { producerId, productId = '' } = useAccessParams()
  return gated(producerId, <MemberFilesPage producerId={producerId} productId={productId} />)
}
